import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Icon, Logo, Mark } from "./ui";
import { NAV } from "../data/constants";
import { useFamilyAuth } from "../store/familyAuthStore";

export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const family = useFamilyAuth((s) => s.family);
  const logout = useFamilyAuth((s) => s.logout);
  const [menuOpen, setMenuOpen] = useState(false);

  const path = location.pathname;
  const isActive = (id) => {
    if (id === "dashboard") return path === "/" || path === "/dashboard";
    if (id === "forms") return path.startsWith("/forms");
    return path.startsWith("/" + id);
  };

  const familyName = family?.full_name || family?.name || "Your";
  const initial = familyName[0] || "S";
  const centre = family?.centre_name || family?.centre || "Stride";

  const go = (href) => {
    setMenuOpen(false);
    navigate(href);
  };

  const signOut = () => {
    setMenuOpen(false);
    logout();
    navigate("/login");
  };

  // Close mobile menu on route change and lock body scroll while open.
  useEffect(() => {
    setMenuOpen(false);
  }, [path]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [menuOpen]);

  return (
    <header className="portal-header">
      <div className="ph-left" onClick={() => go("/dashboard")}>
        <Mark size={34} variant="orange" />
        <Logo variant="color" height={30} />
      </div>

      <nav className="ph-nav" aria-label="Main navigation">
        {NAV.map((n) => (
          <button key={n.id}
            className={"ph-navitem nav-label" + (isActive(n.id) ? " is-active" : "")}
            onClick={() => go("/" + n.id)}>
            {n.label}
          </button>
        ))}
      </nav>

      <div className="ph-right">
        <div className="centre-badge">
          <Icon name="pin" className="ico-15 ico-orange" />
          <span>{centre}</span>
        </div>
        <button className="family-chip" onClick={() => go("/account")}>
          <span className="fc-avatar">{initial}</span>
          <span className="fc-name">{familyName} family</span>
        </button>
        <button className="ph-icon-btn" title="Sign out" onClick={signOut}>
          <Icon name="logout" className="ico-19" />
        </button>
        <button
          type="button"
          className="ph-menu-btn"
          aria-label={menuOpen ? "Close menu" : "Open menu"}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((o) => !o)}
        >
          <Icon name={menuOpen ? "x" : "menu"} className="ico-20" />
        </button>
      </div>

      {/* Mobile drawer */}
      <div className={"ph-mobile" + (menuOpen ? " is-open" : "")} aria-hidden={!menuOpen}>
        <div className="ph-mobile-backdrop" onClick={() => setMenuOpen(false)} />
        <div className="ph-mobile-panel">
          <div className="ph-mobile-head">
            <div className="ph-mobile-user">
              <span className="fc-avatar">{initial}</span>
              <div>
                <div className="account-name">{familyName} family</div>
                <div className="account-email">{family.email}</div>
              </div>
            </div>
            <div className="centre-badge">
              <Icon name="pin" className="ico-15 ico-orange" />
              <span>{centre}</span>
            </div>
          </div>

          <nav className="ph-mobile-nav" aria-label="Mobile navigation">
            {NAV.map((n) => (
              <button key={n.id}
                className={"ph-mobile-link" + (isActive(n.id) ? " is-active" : "")}
                onClick={() => go("/" + n.id)}>
                <Icon name={n.icon} className="ico-18" />
                <span>{n.label}</span>
                <Icon name="chevronRight" className="ico-16 ico-soft" />
              </button>
            ))}
          </nav>

          <div className="ph-mobile-foot">
            <button className="ph-mobile-logout" onClick={signOut}>
              <Icon name="logout" className="ico-18" />
              Sign out
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
